export class CheckUserType {

  isStandard = false;
  isAdmin = false;
  isMaster = false
  isMasterStandard = false
  isPowerUser = false

  initClient(role: string) {
    this.isStandard = role == "Standard" ? true : false;
    this.isAdmin = role == "Admin" ? true : false;
    this.isMaster = role == "Master Admin" ? true : false;
    this.isMasterStandard = role == "Master Standard" ? true : false;
    this.isPowerUser = role == "PowerUser" ? true : false;
  }
}
